import { Modal, Table, Typography } from "antd";
import { EstimateLine } from "./types";
import styles from "./index.module.scss";

const { Text } = Typography;

interface QuantityDetailModalProps {
  open: boolean;
  line: EstimateLine | null;
  onClose: () => void;
}

const QuantityDetailModal = ({
  open,
  line,
  onClose,
}: QuantityDetailModalProps) => {
  if (!line) {
    return null;
  }

  const columns = [
    {
      title: "SO #",
      dataIndex: "refNum",
      key: "refNum",
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      key: "quantity",
      align: "right" as const,
    },
  ];

  return (
    <Modal
      title={`Quantity Breakdown - ${line.sku}`}
      open={open}
      onCancel={onClose}
      centered
      footer={null}
      width={480}
      destroyOnClose
      maskClosable={false}
    >
      {line.name && (
        <p style={{ margin: "0 0 12px", color: "#666" }}>{line.name}</p>
      )}
      <Table
        dataSource={line.quantitySources ?? []}
        columns={columns}
        rowKey={(record) => record.refNum}
        pagination={false}
        size="small"
        className={styles.quantityDetailTable}
        tableLayout="fixed"
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0}>
              <Text strong>Total</Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={1} align="right">
              <Text strong>{line.quantity}</Text>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
    </Modal>
  );
};

export default QuantityDetailModal;
